import Script from 'next/script'

import appConfig from '~/config/app'

const AnalyticsScript = (): React.ReactElement | null => {
  // No marketing tech in the school platform: no GTM container, no Meta Pixel, no Pingdom RUM.
  // The Pixel below is hardcoded with no env guard, so this is the only thing that stops it firing.
  if (appConfig.isSchoolPlatform) return null

  return (
    <>
      {process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_URL && process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID && (
        <Script
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            '${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_URL}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}');`,
          }}
          id="gtm-container-script"
          strategy="afterInteractive"
        />
      )}
      <Script
        dangerouslySetInnerHTML={{
          __html:
            "!function(f,b,e,v,n,t,s){\
if(f.fbq)return;n=f.fbq=function(){n.callMethod?\
n.callMethod.apply(n,arguments):n.queue.push(arguments)};\
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; \
n.queue=[];t=b.createElement(e);t.async=!0;\
t.src=v;s=b.getElementsByTagName(e)[0];\
s.parentNode.insertBefore(t,s)}(window, document,'script',\
'https://connect.facebook.net/en_US/fbevents.js');\
fbq('init', '684181732261197');\
fbq('track', 'PageView');",
        }}
        id="mtpxl"
        strategy="beforeInteractive"
      />
      {process.env.NEXT_PUBLIC_PINGDOM_URL && (
        <Script
          crossOrigin="anonymous"
          id="pingdom-script"
          src={process.env.NEXT_PUBLIC_PINGDOM_URL}
          strategy="afterInteractive"
        />
      )}
    </>
  )
}

export default AnalyticsScript
